<template>
    <v-stepper v-model="currentStep" class="mt-3">
        <v-stepper-header>
            <v-stepper-step :complete="vuex.step1" step="1">Aanvraag</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="vuex.step2" step="2">Contactpersoon</v-stepper-step>

            <v-divider></v-divider>
            <v-stepper-step :complete="vuex.step3" step="3">Controle</v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step
                :rules="[() => currentStep != 4 || !vuex.finish.error]"
                :complete="vuex.finish.complete"
                step="4"
                >Verzonden</v-stepper-step
            >
        </v-stepper-header>
        <v-stepper-items>
            <v-stepper-content :step="currentStep">
                <template v-if="loading">
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="auto">
                            <v-progress-circular color="primary" indeterminate class="ml-auto"></v-progress-circular>
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>
                </template>
                <template v-else>
                    <slot></slot>
                </template>
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    components: {},
    props: {
        currentStep: Number,
        loading: Boolean,
    },
    data: () => ({}),
    computed: {
        ...mapGetters({ vuex: 'stepsComplete' }),
    },
};
</script>
